import { render, staticRenderFns } from "./botEditar.vue?vue&type=template&id=2eea78e9&scoped=true"
import script from "./botEditar.vue?vue&type=script&lang=js"
export * from "./botEditar.vue?vue&type=script&lang=js"
import style0 from "./botEditar.vue?vue&type=style&index=0&id=2eea78e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea78e9",
  null
  
)

export default component.exports